import React from 'react';
import './index.scss';
import { showModal } from '@/components/Modal';
import IssueHistory from '@/components/IssueHistory';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { getClstag } from '@/utils/util';

const IssueHistoryBtn = (props: { vehicleName: string }) => {
  const { vehicleName } = props;
  const cockpitMode = useSelector(
    (state: RootState) => state.newCommon?.cockpitMode
  );
  return (
    <>
      <li
        className="btn-item issue-history"
        onClick={() => {
          showModal({
            content: <IssueHistory vehicleName={vehicleName} />,
            width: 2000,
            title: '工单历史',
            footer: {
              showCancel: true,
              showOk: false,
              cancelFunc: (cb) => cb(),
              cancelText: '关闭',
            },
          });
        }}
        clstag={getClstag(cockpitMode, 'SinglePage_WorkOrderHistory')}
      >
        <i>工单历史</i>
      </li>
    </>
  );
};

export default React.memo(IssueHistoryBtn);
